import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import PhoneInputField from "../../../../components/common/inputFields/PhoneInput";
import { Box } from "../../../../components/styled/Elements";

const UserPersonalInfo = ({
  register,
  control,
  errors,
  watch,
  resetField,
  setValue,
  isEdit,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <FormDataContainer className="user-personal-info">
      <Box className="flex-col-class">
        <Box className="input-wrapper">
          <ValidatedInput
            padding="9px 12px 0px 12px"
            start="start"
            column="column"
            weight="600"
            name={"name"}
            type={"input"}
            fieldType={"text"}
            label="name"
            placeholder={t("namePlaceholder")}
            // staric={true}
            errors={errors}
            register={register}
            validationRules={{ required: true }}
          />
        </Box>
        <Box className="input-wrapper">
          <ValidatedInput
            padding="9px 12px 0px 12px"
            start="start"
            column="column"
            weight="600"
            name={"id_number"}
            type={"input"}
            fieldType={"number"}
            label={t("id")}
            placeholder={t("id")}
            // staric={true}
            register={register}
            errors={errors}
            validationRules={{ required: true }}
          />
        </Box>
      </Box>
      <Box className="flex-col-class">
        <Box className="input-wrapper">
          <ValidatedInput
            padding="9px 12px 0px 12px"
            start="start"
            column="column"
            weight="600"
            name={"job_title"}
            type={"input"}
            fieldType={"text"}
            label="job_title"
            placeholder={t("job_title")}
            // staric={true}
            register={register}
            errors={errors}
            validationRules={{ required: true }}
          />
        </Box>
        <Box className="input-wrapper">
          <ValidatedInput
            padding="9px 12px 0px 12px"
            start="start"
            column="column"
            weight="600"
            name={"email"}
            type={"input"}
            fieldType={"email"}
            placeholder={t("emailPlaceholder")}
            label={t("email")}
            // staric={true}
            register={register}
            errors={errors}
            validationRules={{ required: true }}
          />
        </Box>
      </Box>
      <Box className="flex-col-class">
        <Box className="input-wrapper">
          <PhoneInputField
            padding="9px 12px 0px 12px"
            bg="transparent"
            start="start"
            column="column"
            weight="600"
            name="phone"
            label={"phone"}
            // staric={true}
            placeholder={"phonePlaceholder"}
            register={register}
            control={control}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
        </Box>
        <Box className="input-wrapper">
          <ValidatedInput
            padding="9px 12px 0px 12px"
            start="start"
            column="column"
            weight="600"
            name={"password"}
            type={"input"}
            fieldType={"password"}
            placeholder={t("passwordPlaceholder")}
            label={t("password")}
            // staric={true}
            register={register}
            errors={errors}
            validationRules={{
              required: isEdit ? false : true,
              inline: true,
              minLength: {
                value: 8,
                message: "lengthGreaterThen",
              },
            }}
          />
        </Box>
      </Box>

      <ValidatedInput
        padding="9px 12px 0px 12px"
        start="start"
        column="column"
        weight="600"
        name={"additional_information"}
        type={"textarea"}
        fieldType={"text"}
        label="additional_info"
        placeholder={t("additional_info")}
        // staric={true}
        // className="combined"
        errors={errors}
        register={register}
        validationRules={{ required: false }}
      />
    </FormDataContainer>
  );
};

export default UserPersonalInfo;

const FormDataContainer = styled.div`
  .flex-col-class {
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: 20px;
    width: 100%;
    @media (max-width: 575px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .input-wrapper {
      width: 50%;
      display: flex;
      @media (max-width: 575px) {
        width: 100%;
      }
    }
  }
`;
